import { render } from "./AchievementMobile.vue?vue&type=template&id=4a8c1536"
import script from "./AchievementMobile.vue?vue&type=script&lang=js"
export * from "./AchievementMobile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/connorklaassen/Documents/Programming/cklaassen.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__